import { Dispatch } from 'redux';
import * as actionTypes from './actionTypes';
import * as rd2ApiManager from '../lib/rd2ApiManager';

export interface CareOrderInfoUI {
  id?: number | null;
  referenceId?: string;
  decisionSupportSessionId?: string | null;
  externalReferralOrderId?: string | null;
  expirationDate?: string | Date | null;
  minVisitDate?: string | Date | null;
  maxVisitDate?: string | Date | null;
  approximateVisitDate?: string | Date | null;
  patientReferenceId?: string | null;
  notes?: string | null;
  appointmentTypeId?: number | null;
  appointmentTypeName?: string | null;
  appointmentTypeExternalCode?: string | null;
  specialtyId?: number | null;
  specialtyName?: string | null;
  serviceTypeId?: number | null;
  serviceTypeName?: string | null;
  siteId?: number | null;
  siteName?: string | null;
  siteAddress?: any;
  serviceId?: number | null;
  providerFirstName?: string | null;
  providerLastName?: string | null;
  serviceDisplayName?: string | null;
  referringProviderName?: string | null;
  referringServiceDisplayName?: string | null;
  referringSiteName?: string | null;
  statusCode?: string | null;
  statusDisplayName?: string | null;
  statusReason?: string | null;
  statusReasonId?: number | null;
  createdAt?: string | Date | null;
  updatedAt?: string | Date | null;
  fromEMR?: boolean;
  careOrderType?: string | null;
  careOrderTypeId?: number | null;
  careOrderVisits?: any[] | null;
  orderDate?: string | Date | null;
  productInstanceConsumerName?: string | null;
  lockoutEndAt?: string | Date | null;
  lastNotificationSentAt?: string | Date | null;
  subgroupName?: string | null;
  appointmentReferenceId?: string | null;
  providerAppointmentDateTime?: string | Date | null;
  reasonForVisit?: string | null;
  customFields?: any[] | null;
  patientFirstName?: string | null;
  patientLastName?: string | null;
  patientAlternatePhone?: string | null;
  patientDateOfBirth?: string | Date | null;
  patientMobilePhone?: string | null;
  patientMemberId?: string | null;
  patientHomePhone?: string | null;
  createdBy?: string | null;
  createdByFirstName?: string | null;
  createdByLastName?: string | null;
  lastUpdatedBy?: string | null;
  lastUpdatedByFirstName?: string | null;
  lastUpdatedByLastName?: string | null;
  destination?: string | null;
  questionsAndAnswers?: any[];
  isInactive?: boolean;
  errorMessage?: string | null;
}

export interface CloseCareOrderRequestInfo {
  productInstanceId: number | string;
  careOrderVisitIdentifier?: string;
  externalReferralOrderId?: string;
}

export const setActiveCareOrderDetails = (careOrderInfo: CareOrderInfoUI) => {
  return async (dispatch: Dispatch) => {
    dispatch(setActiveCareOrderDetailsAction(careOrderInfo));
    return Promise.resolve();
  };
};

export function setActiveCareOrderDetailsAction(careOrderInfo: CareOrderInfoUI) {
  return {
    type: actionTypes.SET_ACTIVE_CAREORDERVISIT_DETAILS,
    data: {
      careOrderWorkflowDetails: {
        careOrderVisitIdentifier: careOrderInfo.referenceId,
        externalReferralOrderId: careOrderInfo.externalReferralOrderId,
        expirationDate: careOrderInfo.expirationDate,
        minVisitDate: careOrderInfo.minVisitDate,
        maxVisitDate: careOrderInfo.maxVisitDate,
        approximateVisitDate: careOrderInfo.approximateVisitDate,
        patientReferenceId: careOrderInfo.patientReferenceId,
        notes: careOrderInfo.notes,
        statusCode: careOrderInfo.statusCode,
        statusDisplayName: careOrderInfo.statusDisplayName,
        createdAt: careOrderInfo.createdAt,
        updatedAt: careOrderInfo.updatedAt,
        fromEMR: careOrderInfo.fromEMR,
        careOrderType: careOrderInfo.careOrderType,
        orderDate: careOrderInfo.orderDate,
        productInstanceConsumerName: careOrderInfo.productInstanceConsumerName,
        lockoutEndAt: careOrderInfo.lockoutEndAt,
        lastNotificationSentAt: careOrderInfo.lastNotificationSentAt,
        subgroupName: careOrderInfo.subgroupName,
        errorMessage: careOrderInfo.errorMessage,
        decisionSupportSessionId: careOrderInfo.decisionSupportSessionId,
        questionsAndAnswers: careOrderInfo.questionsAndAnswers,
        destination: careOrderInfo.destination,
        appointments: [{
          appointmentTypeId: careOrderInfo.appointmentTypeId,
          appointmentTypeName: careOrderInfo.appointmentTypeName,
          appointmentTypeExternalCode: careOrderInfo.appointmentTypeExternalCode,
          externalReferralOrderId: careOrderInfo.externalReferralOrderId,
          reasonForVisit: careOrderInfo.reasonForVisit,
          providerFirstName: careOrderInfo.providerFirstName,
          providerLastName: careOrderInfo.providerLastName,
          serviceId: careOrderInfo.serviceId,
          serviceTypeId: careOrderInfo.serviceTypeId,
          serviceTypeName: careOrderInfo.serviceTypeName,
          serviceDisplayName: careOrderInfo.serviceDisplayName,
          referringProviderName: careOrderInfo.referringProviderName,
          referringServiceDisplayName: careOrderInfo.referringServiceDisplayName,
          referringSiteName: careOrderInfo.referringSiteName,
          siteId: careOrderInfo.siteId,
          siteName: careOrderInfo.siteName,
          siteAddress: careOrderInfo.siteAddress,
          specialtyId: careOrderInfo.specialtyId,
          specialtyName: careOrderInfo.specialtyName,
          careOrderCustomField: careOrderInfo.customFields,
        }],
      }
    },
  };
}

export function closeCareOrder(closeCareOrderRequestInfo: CloseCareOrderRequestInfo) {
  return {
    type: actionTypes.CLOSE_CARE_ORDER,
    payload: {
      request: rd2ApiManager.createRequest_CloseCareOrder(closeCareOrderRequestInfo),
    },
  };
}
